'use strict';

import { initCarousel } from '../../../_scripts/helpers';

export default class RelatedFilmNews {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;

    this.carouselOptions = {
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    };

    this.resultCarousel = null;
    if(selfInit) this.init($selector);
  }

  init() {
    this.resultCarousel = initCarousel($('.related-film-news__body [data-carousel]', this.$selector), this.carouselOptions);

    let timer;
    $(window).on('resize.resultsCarousel', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if(this.resultCarousel) {
          this.resultCarousel.unslick();
          this.resultCarousel.slickInit();
        }
      }, 500);
    });
  }
}
